import React from "react";

const LoadingIndicator = props => {
    let loadingClasses = "loading-indicator loading-indicator--visible";
    if (props.type === "page") loadingClasses = `${loadingClasses} loading-indicator--page`
    if (props.className) loadingClasses = `${loadingClasses} ${props.className}`;
    return <div className={loadingClasses}><span className="loading-indicator__inner" /></div>;
}

export default LoadingIndicator;
